export const METRIC_OPTIONS = [
  { value: 'Volume', label: 'Volume' },
  { value: 'Rate', label: 'Rate' },
  { value: 'Proportion', label: 'Proportion' },
];

export const STAGE_OPTIONS = [
  { value: 'Inquiry', label: 'Inquiry' },
  { value: 'Application', label: 'Application' },
  { value: 'Admit', label: 'Admit' },
  { value: 'Net Deposit', label: 'Net Deposit' },
];

export const SELECT_CUSTOM_STYLES = {
  extraBasicStyles: { padding: 0, height: '2' },
  customClass: '!text-sm !leading-4',
};
export const RADIO_OPTIONS = [
  { label: 'Increase', value: 'Increase', colorClass: 'text-success-06' },
  { label: 'Maintain', value: 'Maintain', colorClass: 'text-gray-04' },
  { label: 'Decrease', value: 'Decrease', colorClass: 'text-red-00' },
];
